import { render } from "./LocaleLoadingSpinner.vue?vue&type=template&id=b475034c&scoped=true&ts=true"
import script from "./LocaleLoadingSpinner.vue?vue&type=script&lang=ts"
export * from "./LocaleLoadingSpinner.vue?vue&type=script&lang=ts"

import "./LocaleLoadingSpinner.vue?vue&type=style&index=0&id=b475034c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b475034c"]])

export default __exports__